import { useRequestedHomeSwitch } from '@shared/hooks/useRequestedHomeSwitch'
import useFeatureFlags from 'hooks/useFeatureFlags'
import useHomeType from 'hooks/useHomeType'
import ResidentsScreen from './ResidentsScreen'

export const ResidentScreenFeatureFlagWrapper = () => {
  const { hasRota } = useHomeType()

  useRequestedHomeSwitch()

  const flags = useFeatureFlags({
    flagNames: [
      'communication_records',
      'emar_v2_chart',
      'mods_alerts',
      'procedures',
      'referrals',
      'service_records',
      'transfer_records',
      'device_records'
    ]
  })?.data

  const alertsEnabled = flags?.mods_alerts?.enabled ?? false
  const communicationRecordsEnabled = flags?.communication_records?.enabled
  const proceduresEnabled = flags?.procedures?.enabled ?? false
  const referralsEnabled = flags?.referrals?.enabled ?? false
  const serviceRecordsEnabled = flags?.service_records?.enabled ?? false
  const transferRecordsEnabled = flags?.transfer_records?.enabled ?? false
  const deviceRecordsEnabled = flags?.device_records?.enabled ?? false
  const emarChartV2Enabled = flags?.emar_v2_chart?.enabled

  return (
    <ResidentsScreen
      hasRota={hasRota}
      alertsEnabled={alertsEnabled}
      communicationRecordsEnabled={communicationRecordsEnabled}
      proceduresEnabled={proceduresEnabled}
      referralsEnabled={referralsEnabled}
      serviceRecordsEnabled={serviceRecordsEnabled}
      transferRecordsEnabled={transferRecordsEnabled}
      deviceRecordsEnabled={deviceRecordsEnabled}
      emarChartV2Enabled={emarChartV2Enabled}
      data-testid="residents-screen-wrapper"
    />
  )
}
